import React from 'react';
import { Link } from 'react-router-dom';

export default class MyCoursesThisMonth extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: false,
            courses: [],
            displayCourses: [],
            selectedMonth: new Date().getMonth() + 1,
        }
    }
    componentDidMount()
    {
        this.loadMyCourses();
    }
    loadMyCourses()
    {
        this.props.api.send({
            controller: "Course",
            action: "LoadMyCourses",
            method: "get",
            success: (response) => {


                let displayCourses = this.filterCourses(new Date().getMonth, response.courses);

                response.success ?
                    this.setState({loaded: true, courses: response.courses, displayCourses: displayCourses}) :
                    this.setState({loaded: true, error: true})
                this.getCourseCategories();
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    getCourseMonths()
    {
        return [
            {MonthOfYear: 1, MonthName: "January"},
            {MonthOfYear: 2, MonthName: "February"},
            {MonthOfYear: 3, MonthName: "March"},
            {MonthOfYear: 4, MonthName: "April"},
            {MonthOfYear: 5, MonthName: "May"},
            {MonthOfYear: 6, MonthName: "June"},
            {MonthOfYear: 7, MonthName: "July"},
            {MonthOfYear: 8, MonthName: "August"},
            {MonthOfYear: 9, MonthName: "September"},
            {MonthOfYear: 10, MonthName: "October"},
            {MonthOfYear: 11, MonthName: "November"},
            {MonthOfYear: 12, MonthName: "December"}
        ];
    }
    filterChanged(e)
    { 
        let selectedValue = Number(e.target.value)
        let filteredCourses = this.state.courses;
        if(selectedValue !== 0)
            filteredCourses = this.filterCourses(selectedValue, filteredCourses);
        else
            filteredCourses = this.state.courses;
        this.setState({displayCourses: filteredCourses, selectedMonth: selectedValue})
    }
    filterCourses(month, courses){
        return courses.filter(c => (c.dueDate !== null) && ((new Date(c.dueDate).getMonth() + 1) === month))
    }
    render()
    {
        const filterDated = this.state.displayCourses.filter(c => (c.dueDate !== null))
        const courselist = filterDated.map((c) =>
            <tr key={c.courseID}>
                <td>{c.courseName}</td>
                <td>{c.courseDescription}</td>
                <td style={{width: "275px"}}>
                    <Link to={"/LaunchCourse/" + c.courseID} className="lmsbutton">Launch Course</Link>
                    <Link to="#" className="lmsbutton">My Results</Link>
                </td>
            </tr>
        )
        const monthFilters = this.getCourseMonths();
        return (
            <div>
                
                <strong>Courses Due:</strong>
                <select className="lmsforminput" style={{marginBottom: "12px", display: "block"}} 
                    onChange={(e) => this.filterChanged(e)}
                    value={this.state.selectedMonth}>
                    <option value="0">-- All --</option>
                    {monthFilters.map(m => 
                        <option key={m.MonthOfYear} value={m.MonthOfYear}>{m.MonthName}</option>  
                    )}
                </select>
                {this.state.loaded ?
                    this.state.displayCourses.length > 0 ? (
                        <div style={{marginTop: "10px"}}>
                            <table className="lmstable" style={{marginTop: "12px"}}>
                                <tbody>
                                    <tr>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Actions</th>
                                    </tr>
                                    {courselist}
                                </tbody>
                            </table>                            
                        </div>
                    ) : (
                    <p>
                        <i>You do not currently have any courses available. Check the Course Catalog for available courses.</i>
                    </p>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/mycoursesthismonth.js